(function ($, window, undefined) {

    'use strict';


    var formatarTelefone = function (val) {
        return val.replace(/\D/g, '').length === 9 ? '00000-0000' : '0000-00009';
    },
    telefoneOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(formatarTelefone.apply({}, arguments), options);
        }
    };


    $('.telefone').mask(formatarTelefone, telefoneOptions);


    if (window.location.hash == '#ligar') {
        setTimeout(function () {
            $('#call-me').fadeIn();
            $('.backdrop').addClass('visible');
        }, 2000);

    }

    $('.calling a').on('click', function () {
        $('#call-me').fadeIn();
        $('.backdrop').addClass('visible');
        $('body').css('overflow', 'hidden');
        $('#call-me').niceScroll();
        return false;
    });


    $('.close-popup').on('click', function () {
        $('.backdrop').removeClass('visible');
        $('#call-me').fadeOut();
        $('body').css('overflow', 'visible');
        return false;
    });

    $('.call-later').on('click', function () {
        var loginData = { 'grant_type': 'password', 'username': 'sistema', 'password': 'proc14' };
        var splitdate = $('.agendamento').find('.data').val().split('-');
        var dataFormatada = (splitdate[2] + '/' + splitdate[1] + '/' + splitdate[0]);


        var dataForm = {
            'Nome': $('.agendamento').find('input[name="Nome"]').val(),
            'Email': $('.agendamento').find('input[name="Email"]').val(),
            'Mensagem': $('.agendamento').find('input[name="Mensagem"]').val(),
            'Telefone': '(' + $('.agendamento').find('.ddd').val() + ') ' + $('.agendamento').find('.telefone').val(),
            "Origem": $('.agendamento').find('input[name="Origem"]').val(),
            "identificador": $('.agendamento').find('input[name="identificador"]').val(),
            "Observacao": 'Ligar dia: ' + dataFormatada + ' as ' + $('.agendamento').find('.horario').val()
        };

        var TOKEN = 'd7ad0e96fa3a180769d57afa87b7ce3f'; // token de exemplo

        var data_array = [
            { name: 'email', value: dataForm.Email },
            { name: 'telefone', value: dataForm.Telefone },
            { name: 'identificador', value: dataForm.identificador },
            { name: 'observacao', value: dataForm.Observacao },
            { name: 'origem', value: dataForm.Origem },
            { name: 'nome', value: dataForm.Nome },
            { name: 'token_rdstation', value: TOKEN }
        ];

        if (!dataForm.Nome) {
            mensagem('error-msg', 'Por favor preencha o campo nome.');
        } else if (!dataForm.Email) {            
            mensagem('error-msg', 'Por favor preencha o campo e-mail.');
        } else if (!checkMail(dataForm.Email)) {
            mensagem('error-msg', 'Email inválido.');
        } else if (!dataForm.Mensagem) {
            mensagem('error-msg', 'Por favor preencha o campo assunto.');
        } else if (!$('.agendamento').find('.telefone').val()) {
            mensagem('error-msg', 'Por favor preencha o campo telefone.');
        } else if (!$('.agendamento').find('.ddd').val()) {
            mensagem('error-msg', 'Por favor preencha o campo ddd.');
        } else if (!$('.agendamento').find('.horario').val()) {
            mensagem('error-msg', 'Por favor preencha o campo horário.');
        } else if (!$('.agendamento').find('.data').val()) {
            mensagem('error-msg', 'Por favor preencha o campo data.');
        } else {
            RdIntegration.post(data_array);
            agendar(dataForm);
        }



    });


    $('.callnow').on('click', function () {
        if ($(this).siblings('.ddd').val().length >= 2 && $(this).siblings('.telefone').val().length >= 8) {
            var ddd = $(this).siblings('.ddd').val();
            var telefone = $(this).siblings('.telefone').val();
            ligar(ddd, telefone);
        } else {
            mensagem('error-msg', 'Por favor preencha corretamente os campos DDD e Telefone.');
        }
    });

    verifyHour();


})(jQuery, window);

function checkMail(mail) {
    var er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);
    if (typeof (mail) == "string") {
        if (er.test(mail)) { return true; }
    } else if (typeof (mail) == "object") {
        if (er.test(mail.value)) { return true; }
    } else { return false; }
}

function verifyHour() {

    if ($('input.horaServidor').val() > 18) {
        $('.box-call.half-one').hide();
        $('#call-me #callcontainer .outofhour').show();
    }
    //var targetDate = new Date();
    //var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60;


    //$.ajax({
    //    url: 'https://maps.googleapis.com/maps/api/timezone/json?location=-15.7942287,-47.8821658&timestamp=' + timestamp + '&language=pt-BR&key=AIzaSyC6Z0hywPsr47PEsRLODqqd5jFXBR7zrbQ',
    //    //url: 'https://maps.googleapis.com/maps/api/timezone/json?location=39.6034810,-119.6822510&timestamp='+timestamp+'&language=pt-BR&key=AIzaSyC6Z0hywPsr47PEsRLODqqd5jFXBR7zrbQ',
    //    dataType: 'json',
    //    async: false,
    //    cache: false,
    //    success: function (data) {
    //        // console.log(data);
    //        var dataCompleta = CalcDate(data.rawOffset + data.dstOffset);
    //        if (dataCompleta.getHours() > 18) {
    //            $('.box-call.half-one').hide();
    //            $('#call-me #callcontainer .outofhour').show();
    //        }



    //    }
    //});
}


function fecharModal() {
    $('#call-me').fadeOut();
    $('#call-me #agendamentosuccess, #call-me #ligandosuccess').hide();
    $('#call-me #callcontainer').show();
    $('.backdrop').removeClass('visible');
    $('body').css('overflow', 'visible');
}


function showAgendamento() {
    $('#call-me #callcontainer').fadeOut(function () {
        $('#call-me #agendamentosuccess').fadeIn();
    });
    setTimeout(function () {
        fecharModal();
    }, 10000);

}

function showLigando() {
    $('#call-me #callcontainer').fadeOut(function () {
        $('#call-me #ligandosuccess').fadeIn();
    });
    setTimeout(function () {
        fecharModal();
    }, 10000);

}

function mensagem(type, msg) {

    // mensagem('error-msg', 'Em Instantes entraremos em contato.');

    $('<div/>', {
        'class': type,
        'text': msg
    }).appendTo('#call-me');

    setTimeout(function () {
        $('.' + type).fadeOut(function () {
            $(this).remove();
        });
    }, 3000);


}

function ligar(ddd, telefone) {

    telefone = telefone.replace(/-/g, "");

    $.ajax({

        crossDomain: true,
        url: 'https://ssl-dial.directcallsoft.com/dc0800web/discador/discar',

        data: {
            pinHash: '6cca0eb7e0e99b48ec39e1f30569d6cd',
            pais: 55,
            foneBrasil: '',
            callClicked: '',
            codArea: ddd,
            destino: telefone
        },

        type: 'POST',

        beforeSend: function () {
            showLigando();

        },
        success: function (response) {


        }
    });
}

function agendar(dados) {

    var loginData = { 'grant_type': 'password', 'username': 'sistema', 'password': 'proc14' };
    $.ajax({
        type: 'POST',
        url: 'https://integracao.advisebrasil.com.br/prospeccao/token',        
        //url: 'http://localhost:33389/token',
        data: loginData,
        beforeSend: function () {
            showAgendamento();
        }
    }).done(function (data) {

        tokenSeguros = data.access_token;
        console.log('Token: ' + tokenSeguros);


        // Dados do formulário
        var dataForm = dados;

        if (!dataForm.Nome) {
            mensagem('error-msg', 'Por favor preencha o campo nome.');
        } else if (!dataForm.Telefone) {
            mensagem('error-msg', 'Por favor preencha o campo Telefone.');
        } else {            
            $.ajax({
                url: 'https://integracao.advisebrasil.com.br/prospeccao/api/contato/cadastrarLeadSeguroBerkley',
                //url: 'http://localhost:33389/api/contato/cadastrarLeadSeguroBerkley',
                type: 'POST',
                data: dataForm,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + tokenSeguros);

                },
                success: function (data) {
                    if (data == 'Operação realizada com sucesso.') {
                        //mensagem('success-msg', 'Em breve um consultor entrará em contato.');
                    }
                },
                error: function (data) {
                    mensagem('error-msg', 'Ocorreu um erro na sua solicitação.');
                }
            });
        }

    }).fail(function (error) {
        console.log('Error:' + error.responseText);
    });

    return false;
}

//function CalcDate(offsetSum) {
//    var data = new Date();
//    var utc = data.getTime() + (data.getTimezoneOffset() * 60000);
//    var full = new Date(utc + (1000 * offsetSum));
//    return full;
//}

